<template>
  <div id="app">
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <router-view />

    <b-modal v-model="qesg_image_modal" hide-header hide-footer centered size="xl" body-class="p-0">
      <object v-if="isSvg" :data="img_src" type="image/svg+xml" style="max-width: 80vw; height: 70vh;"></object>

      <b-img v-else :src="img_src" center style="max-width: 80vw; height: 70vh;"/>
    </b-modal>
  </div>
</template>

<script>
  import toastMixin from '@/mixins/toastMixin';

  export default {
    mixins: [toastMixin],
    data() {
      return {
        img_src: '',
        qesg_image_modal: false,
      };
    },
    computed: {
      isSvg() {
        return this.img_src && this.img_src.toLowerCase().endsWith('.svg');
      }
    },
    methods: {
      makeModal(src, show) {
        this.img_src = src;
        this.qesg_image_modal = show;
      },
    },
    created() {
      this.$EventBus.$on('image-modal', this.makeModal);
    },
  };
</script>

<style></style>
